<template>
  <v-dialog
    :value="show"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    :transition="$vuetify.breakpoint.smAndDown ? 'dialog-bottom-transition' : 'dialog-transition'"
    :width="$vuetify.breakpoint.mdAndUp ? 500 : null"
    :persistent="$vuetify.breakpoint.mdAndUp"
  >
    <v-card>
      <v-card-title class="primary white--text headline justify-space-between">
        Ajouter une exception
        <span class="pointer" @click="$emit('close')">&times;</span>
      </v-card-title>
      <v-card-text class="pt-5" v-if="selectedTeam">
        <h2 class="mb-5">Choisir une équipe</h2>
        <v-select v-model="selectedTeam" outlined :items="teams.map((t) => ({ text: t.name, value: t }))"></v-select>
        <v-select
          v-model="availability.available"
          outlined
          :items="[
            { text: 'Disponibilité', value: true },
            { text: 'Indisponbilité', value: false },
          ]"
        ></v-select>
        <v-date-picker v-model="availability.date" label="Date" style="width: 100%"></v-date-picker>
        <IriadeMaskedTextInput
          v-model="availability.start"
          label="Heure de début"
          hint="Exemple : 09:30"
          mask="##:##"
        ></IriadeMaskedTextInput>
        <IriadeMaskedTextInput v-model="availability.end" label="Heure de fin" hint="Exemple : 17:00" mask="##:##"></IriadeMaskedTextInput>
        <v-btn class="primary" block :loading="loading" @click="submit">Valider </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "api";

export default {
  data: () => ({
    loading: false,
    teams: [],
    selectedTeam: null,
    availability: {
      date: null,
      available: true,
      start: null,
      end: null,
    },
  }),

  methods: {
    submit() {
      this.loading = true;
      api
        .post("d/availabilities", {
          start: this.availability.start,
          end: this.availability.end,
          date: this.availability.date,
          team_id: this.selectedTeam.id,
          available: this.availability.available ? 1 : 0,
        })
        .then((_) => {
          this.loading = false;
          this.$emit("close");
        });
    },
  },

  async mounted() {
    this.teams = (await api.get("evision/shops-list")).data;
    this.selectedTeam = this.teams[0];
  },

  props: {
    show: {
      required: true,
      type: Boolean,
    },
  },
};
</script>
